import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { authAPI } from '../services/api';
import api from '../services/api';
import { toast } from '../hooks/use-toast';
import { X, Zap, Loader2 } from 'lucide-react';

const ExpressRegisterPopup = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const checkoutPath = ['/checkout', '/cart', '/thank-you'].includes(pathname) || pathname.startsWith('/guest-order/');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '' });

  useEffect(() => {
    if (user || checkoutPath) { setShow(false); return; }
    if (sessionStorage.getItem('zl_express_dismissed')) return;

    const timer = setTimeout(async () => {
      try {
        const res = await api.get('/marketing/popup-config');
        if (res.data.is_express_popup_active) setShow(true);
      } catch { /* silent */ }
    }, 5000);
    return () => clearTimeout(timer);
  }, [user, checkoutPath]);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem('zl_express_dismissed', '1');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.password) return;
    setLoading(true);
    try {
      const res = await authAPI.register({ name: form.name, email: form.email, password: form.password, role: 'buyer' });
      login(res.user);
      toast({ title: '¡Bienvenido a Zona Libre!' });
      dismiss();
    } catch (err) {
      toast({ title: 'Error', description: err.response?.data?.detail || 'Error al registrar', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  if (!show || checkoutPath || user) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4" data-testid="express-register-popup">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={dismiss} />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden animate-in zoom-in-95">
        <button onClick={dismiss} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 z-10">
          <X className="w-5 h-5" />
        </button>
        <div className="bg-gradient-to-r from-orange-500 to-amber-400 p-6 text-center text-white">
          <Zap className="w-10 h-10 mx-auto mb-2" />
          <h2 className="text-xl font-black">Registro Expres</h2>
          <p className="text-sm text-white/80 mt-1">Crea tu cuenta en 10 segundos</p>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-3">
          <Input placeholder="Tu nombre" value={form.name} onChange={e => setForm(p => ({...p, name: e.target.value}))} required data-testid="express-name" />
          <Input type="email" placeholder="tu@email.com" value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))} required data-testid="express-email" />
          <Input type="password" placeholder="Contraseña" value={form.password} onChange={e => setForm(p => ({...p, password: e.target.value}))} required data-testid="express-password" />
          <Button type="submit" disabled={loading} className="w-full bg-orange-500 hover:bg-orange-600 text-white h-11" data-testid="express-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Crear cuenta gratis'}
          </Button>
          <p className="text-center text-xs text-gray-400">
            Ya tienes cuenta? <button type="button" onClick={() => { dismiss(); navigate('/login'); }} className="text-orange-500 hover:underline">Ingresa</button>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ExpressRegisterPopup;
